import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { PageTitle } from "../../components/Layout";
import { missionCategory } from "../../components/MissionPanel";
import { MissionCard } from "../../components/MissionCard";
import { PageSkeleton } from "../../components/Feedback";
import VisioAgenda from "../../components/VisioAgenda";
import * as Icons from "lucide-react";

export default function CollabDashboard() {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/collab/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <PageSkeleton />;

  return (
    <div>
      <PageTitle overline={d.role} title={`Bonjour, ${d.name}`} />
      <div className="mb-8">
        <VisioAgenda items={d.upcoming_rdvs || []} showClient missionPath={(v) => `/missions/${v.mission_id}`} />
      </div>
      <div className="mb-10">
        <div className="bg-sable rounded-sm border border-marine/10 shadow-sm p-6" data-testid="collab-pending">
          <h2 className="font-display text-xl text-marine mb-4">Tâches en attente</h2>
          {d.pending.length === 0 && <p className="text-sm text-marine/80">Aucune urgence. Bon travail.</p>}
          <div className="space-y-2">
            {d.pending.map((t, i) => (
              <button key={i} onClick={() => nav(`/missions/${t.mission_id}`)} className="w-full text-left flex items-center gap-3 p-3 rounded-sm border border-marine/10 hover:border-marine/40 transition-all">
                <span className={`w-2 h-2 rounded-full ${t.type === "correction" ? "bg-bordeaux" : "bg-rouge"}`} />
                <span className="text-sm flex-1">{t.label}</span>
                <Icons.ChevronRight size={16} className="text-marine" />
              </button>
            ))}
          </div>
        </div>
      </div>

      {(() => {
        // « Missions à venir » sous « Missions en cours » (recette du 15/10 ; décision de Mélilia, question 14) : une
        // mission tout juste confiée reste « à venir » tant que rien n'a bougé, alors que sa première phase est ouverte.
        const enCours = (d.missions || []).filter((m) => missionCategory(m) === "en_cours");
        const aVenir = (d.missions || []).filter((m) => missionCategory(m) === "a_venir");
        const block = (title, list, testid, empty) => (
          <div data-testid={testid}>
            <div className="flex items-center gap-3 mb-4">
              <h2 className="text-xs uppercase tracking-[0.2em] font-semibold text-bordeaux">{title}</h2>
              <div className="flex-1 h-px bg-marine/10" />
              <span className="text-xs text-marine/80">{list.length}</span>
            </div>
            {list.length === 0 ? (
              <p className="text-sm text-marine/80">{empty}</p>
            ) : (
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {list.map((m) => <MissionCard key={m.id} m={m} onOpen={() => nav(`/missions/${m.id}`)} />)}
              </div>
            )}
          </div>
        );
        return (
          <div className="space-y-10">
            {block("Missions en cours", enCours, "collab-inprogress", "Aucune mission en cours.")}
            {aVenir.length > 0 && block("Missions à venir", aVenir, "collab-upcoming")}
          </div>
        );
      })()}
    </div>
  );
}
